class RecentlyViewedProducts extends HTMLElement {
    constructor() {
        super();
        this.container = this.querySelector('.grid');
        this.limit = parseInt(this.dataset.limit) || 4;
        this.init();
    }

    async init() {
        let handles = [];
        try {
            handles = JSON.parse(localStorage.getItem('recently_viewed') || '[]');
        } catch (e) { }

        const currentHandle = this.dataset.currentProduct || '';
        const handlesToFetch = handles.filter(h => h !== currentHandle).slice(0, this.limit);

        if (handlesToFetch.length === 0) {
            this.style.display = 'none';
            return;
        }

        let rootUrl = this.dataset.rootUrl || '/';
        if (!rootUrl.endsWith('/')) {
            rootUrl = `${rootUrl}/`;
        }

        const fetchPromises = handlesToFetch.map(handle => {
            const url = `${rootUrl}products/${handle}?section_id=recently-viewed-card`;
            return fetch(url).then(res => res.text());
        });

        try {
            const results = await Promise.all(fetchPromises);
            let hasContent = false;

            this.container.innerHTML = '';

            results.forEach(res => {
                const doc = new DOMParser().parseFromString(res, 'text/html');
                const section = doc.querySelector('.shopify-section') || doc.body;

                if (section && section.innerHTML.trim().length > 0) {
                    const li = document.createElement('li');
                    li.className = 'grid__item';
                    li.innerHTML = section.innerHTML;
                    this.container.appendChild(li);
                    hasContent = true;
                }
            });

            if (hasContent) {
                this.classList.remove('hidden');
            } else {
                this.style.display = 'none';
            }
        } catch (e) {
            console.error('Error loading recently viewed products', e);
            this.style.display = 'none';
        }
    }
}
customElements.define('recently-viewed-products', RecentlyViewedProducts);
